import { createTyper } from "@mobx/services/http";
import { GetCurrentUserResponse, UsersResponseI } from "@services/getUsers";
import W2UiFilterBuilder from "@services/w2ui";
import { SearchItem } from "@services/w2ui/w2const";
import { castResponse, Method, RequestArgs, RequestHandle } from "wl-net";

export const GetUserById_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    userid: number
  ): RequestArgs<string> {
    const builder = new W2UiFilterBuilder();
    builder.setSearch([SearchItem.textIs("userid", `${userid}`)]);
    const params = builder.build().stringParams;
    return {
      handle,
      method: Method.Post,
      URL: "/admin/user/list",
      payload: params,
    };
  },
  makeResponse: castResponse<GetCurrentUserResponse>,
});

export const GetUsersRequests_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    offset = 0,
    limit = 20,
    search?: string
  ): RequestArgs<string> {
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
    if (search && typeof search === "string") {
      builder.setSearch([
        SearchItem.textContains("search", search.toLowerCase()),
      ]);
    }
    const params = builder.build().stringParams;
    return {
      handle,
      method: Method.Post,
      URL: "/admin/user/list",
      payload: params,
    };
  },
  makeResponse: castResponse<UsersResponseI>,
});
